import { daoPost } from 'mrf/Dao';
import { useFormDataSelector, useFormSelector } from 'mrf/redux/ReduxHelper';
import { userErrorHandler } from 'mrf/utils/LoginUtils';
import Button from 'mrf/view/Button';
import { FormContext } from 'mrf/view/FormCRUD';
import { Col, Grid } from 'mrf/view/Grid';
import Paper from 'mrf/view/Paper';
import TextField from 'mrf/view/TextField';
import PageTitle from 'mrf/view/Title';
import React from 'react';
import notification, { TYPE } from 'mrf/utils/notification';

export default function ForgotPasswordForm({ history }) {
    const endpoint = '/api/users/forgotPassword';

    const context = useFormSelector({
        resource: 'forgotPassword',
    });

    const data = useFormDataSelector(context);

    const backToLoginPage = () => {
        history.push('/');
    }

    const handleSubmit = async e => {
        e.preventDefault();

        try {
            const clean_data = { ...data };
            delete clean_data._meta;

            const ret = await daoPost(endpoint, clean_data);
            notification({ type: TYPE.DEFAULT, message: ret?.message });
            backToLoginPage();
        } catch (e) {
            userErrorHandler(e, context);
        }
    }

    return <FormContext.Provider value={context}>
        <Paper as='form' onSubmit={handleSubmit}>
            <Grid gap={4}>
                <Col size={12}>
                    <PageTitle>Forgot Password?</PageTitle>
                </Col>
                <Col size={12}>
                    <TextField
                        type='email'
                        label='Email'
                        field='email'
                    />
                </Col>
                <Col size={12}></Col>
                <Col size={6}>
                    <Button color='secondary' onClick={backToLoginPage}>Back</Button>
                </Col>
                <Col size={6}>
                    <Button color='primary' type='submit'>Recover Password</Button>
                </Col>
            </Grid>
        </Paper>
    </FormContext.Provider>
}
